import { useUserStore } from '~/stores/user'
import { useRewardAnalyticsContext } from '~/composables/useRewardAnalyticsContext'
import {
  createRewardAnalyticsTracker,
  REWARD_ANALYTICS_SOURCES,
} from '~/utils/rewardAnalytics.js'
import { AppMessage } from '~/utils/appMessage'

export function useRewardCenter() {
  const { t } = useI18n()
  const userStore = useUserStore()
  const route = useRoute()
  const nuxtApp = useNuxtApp()
  const rewardLog = createRewardAnalyticsTracker(nuxtApp, userStore, route)
  const { setAuthContext } = useRewardAnalyticsContext()
  const isOpen = useState('reward-center-open', () => false)
  const activeView = useState('reward-center-view', () => 'rewards')
  const reopenAfterLogin = useState('reward-center-reopen-after-login', () => false)

  function open(view = 'rewards', options = {}) {
    const source = String(options.source || REWARD_ANALYTICS_SOURCES.navGift)
    const triggerType = options.triggerType === 'pop' ? 'pop' : 'click'
    const wasOpen = isOpen.value
    reopenAfterLogin.value = false
    activeView.value = ['rewards', 'history', 'terms'].includes(view) ? view : 'rewards'
    isOpen.value = true
    rewardLog.dialogOpen({
      source,
      trigger_type: triggerType,
      status: 'success',
      open_result: wasOpen ? 'already_open' : 'opened',
    })
    return true
  }

  function requestLogin(source = REWARD_ANALYTICS_SOURCES.navGift, triggerType = 'click') {
    if (userStore.userName) return false
    AppMessage.warning(t('login.signin_first'))
    reopenAfterLogin.value = isOpen.value
    setAuthContext({ from: String(source), triggerType })
    userStore.setLoginModalShow(true)
    return true
  }

  function resumeAfterLogin() {
    if (!reopenAfterLogin.value || !userStore.userName) return false
    reopenAfterLogin.value = false
    isOpen.value = true
    return true
  }

  function close() {
    isOpen.value = false
    activeView.value = 'rewards'
    reopenAfterLogin.value = false
  }

  function show(view) {
    activeView.value = view
  }

  return {
    isOpen,
    activeView,
    open,
    close,
    show,
    requestLogin,
    resumeAfterLogin,
  }
}
